import { getParentByClass } from "../../../resources/js/helper/helper";

(function () {
  const projectlistLoadMoreBtn = document.querySelectorAll(
    ".com-projectlist__loadmore"
  );

  for (let i = 0; i < projectlistLoadMoreBtn.length; i++) {
    projectlistLoadMoreBtn[i].addEventListener("click", function (event) {
      const showCount = projectlistLoadMoreBtn[i].dataset.loadmore;
      const projectWrapper = getParentByClass(
        projectlistLoadMoreBtn[i],
        "com-projectlist__inner"
      );

      // get all listelements
      const projectList = projectWrapper.querySelectorAll(
        ".com-projectlist__single"
      );
      const projectListArray = [].slice.call(projectList);

      // get hidden listelements
      const hiddenProjects = projectListArray.filter(function (el) {
        return getComputedStyle(el).display === "none";
      });

      // show the next elements
      let x = 0;
      while (x < showCount) {
        if (x in hiddenProjects) {
          hiddenProjects[x].classList.remove("hidden");
        }
        x++;
      }

      // hide button if all elements visible
      if (showCount >= hiddenProjects.length) {
        projectlistLoadMoreBtn[i].style.display = "none";
      }
    });
  }
})();
